
class EditAddressModalCtrl {
    constructor(shipping, locale, SweetAlert, $http, $uibModalInstance) {
        this.shipping = shipping;
        this.locale = locale;
        this.sweetAlert = SweetAlert;
        this.api = $http;
        this.uibModalInstance = $uibModalInstance;

        this.locale.ready(['shipping']);
    }

    close() {
        this.uibModalInstance.close();
    }

    save() {
        console.log('save shipping', this.shipping);
        this.api.post(`shipping/${this.shipping.id}`, {
            shipping: this.shipping
        }).then(() => {
            this.sweetAlert.success('Update address', 'Address successfully updated');
            this.close();
        }, response => {
            console.log(response);
            if (response.code === 422) {
                const msg = Object.values(response.data).map(line => line[0]).join(' ');
                this.sweetAlert.error('A required field is missing:', msg);
            } else {
            this.sweetAlert.error('An error occurred during address update', response.data.message);
            }
        });
    }
}

EditAddressModalCtrl.$inject = [
    'shipping',
    'locale',
    'SweetAlert',
    '$http',
    '$uibModalInstance'
];

angular
    .module('festzelt-os.shippings')
    .controller('EditAddressModalCtrl', EditAddressModalCtrl);



// WEBPACK FOOTER //
// ./src/app/pages/shippings/controllers/edit-address-modal-controller.js